
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import TooltipWindow from '@/components/windows/TooltipWindow.vue';
import PreviewJobHeader from '@/components/jobDetailed/previewJob/PreviewJobHeader.vue';
import PreviewJobLoadBody from '@/components/jobDetailed/previewJob/PreviewJobLoadBody.vue';
import { JobDetailedData } from '@/models/jobDetailed';

@Component({
  components: {
    TooltipWindow,
    PreviewJobHeader,
    PreviewJobLoadBody,
  },
})
export default class AffiliatedJobsTooltipLink extends Vue {
  @Prop(Number) public jobId: number;

  public isShow = false;
  public jobDate = '';

  @Watch('isShow', { immediate: true })
  private watchIsShow(isShow: boolean) {
    if (isShow) {
      document.addEventListener('keydown', this.handleEsc);
    } else {
      this.jobDate = '';
      document.removeEventListener('keydown', this.handleEsc);
    }
  }

  public handleLoaded(job: JobDetailedData): void {
    this.jobDate = job.rockhopper_date;
  }

  public handleEsc(event) {
    if (event.key === 'Escape') {
      this.isShow = false;
    }
  }

  public onClickOutside() {
    this.isShow = false;
  }

  public include() {
    return [this.$refs.link];
  }
}
